/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_End_Time_Last_EventInputs */

const en_new_end_time_last_event = /** @type {(inputs: New_End_Time_Last_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New end time of last event`)
};

const fr_new_end_time_last_event = /** @type {(inputs: New_End_Time_Last_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouvelle fin du dernier événement`)
};

const de_new_end_time_last_event = /** @type {(inputs: New_End_Time_Last_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue Endzeit der letzten Veranstaltung`)
};

const it_new_end_time_last_event = /** @type {(inputs: New_End_Time_Last_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuova ora di fine dell'ultimo evento`)
};

const ru_new_end_time_last_event = /** @type {(inputs: New_End_Time_Last_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Новое время окончания последнего события`)
};

const es_new_end_time_last_event = /** @type {(inputs: New_End_Time_Last_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nueva hora de finalización del último evento`)
};

const zh_cn2_new_end_time_last_event = /** @type {(inputs: New_End_Time_Last_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上次事件的新结束时间`)
};

const ja_new_end_time_last_event = /** @type {(inputs: New_End_Time_Last_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最後のイベントの新しい終了時間`)
};

const hi_new_end_time_last_event = /** @type {(inputs: New_End_Time_Last_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अंतिम आयोजन का नया समाप्ति समय`)
};

const pt_pt2_new_end_time_last_event = /** @type {(inputs: New_End_Time_Last_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novo horário de término do último evento`)
};

/**
* | output |
* | --- |
* | "New end time of last event" |
*
* @param {New_End_Time_Last_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_end_time_last_event = /** @type {((inputs?: New_End_Time_Last_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_End_Time_Last_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_new_end_time_last_event(inputs)
	if (locale === "de") return de_new_end_time_last_event(inputs)
	if (locale === "it") return it_new_end_time_last_event(inputs)
	if (locale === "ru") return ru_new_end_time_last_event(inputs)
	if (locale === "es") return es_new_end_time_last_event(inputs)
	if (locale === "zh-CN") return zh_cn2_new_end_time_last_event(inputs)
	if (locale === "ja") return ja_new_end_time_last_event(inputs)
	if (locale === "hi") return hi_new_end_time_last_event(inputs)
	if (locale === "pt-PT") return pt_pt2_new_end_time_last_event(inputs)
	return en_new_end_time_last_event(inputs)
});